import client from './client';

const API_URL = process.env.REACT_APP_API_URL;

export const mediaApi = {
  list: (type, unusedOnly) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    if (unusedOnly) params.set('unused', '1');
    const query = params.toString();
    return client.get(`/admin/media${query ? `?${query}` : ''}`);
  },
  remove: (id) => client.delete(`/admin/media/${id}`),

  /** Upload multipart — ne passe pas par client.js (JSON only) */
  async upload(file, altText) {
    const token = localStorage.getItem('access_token');
    const formData = new FormData();
    formData.append('fichier', file);
    if (altText) formData.append('alt_text', altText);

    const response = await fetch(`${API_URL}/admin/media`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      const error = new Error(data?.error || "Échec de l'upload");
      error.errors = data?.errors || {};
      throw error;
    }

    return data;
  },
};
